'use client';
"use strict";

var _excluded = ["isDisabled", "children"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Tag: function Tag() {
    return _Tag;
  },
  TagCloseButton: function TagCloseButton() {
    return _TagCloseButton;
  },
  TagLabel: function TagLabel() {
    return _TagLabel;
  },
  TagLeftIcon: function TagLeftIcon() {
    return _TagLeftIcon;
  },
  TagRightIcon: function TagRightIcon() {
    return _TagRightIcon;
  },
  useTagStyles: function useTagStyles() {
    return _useTagStyles;
  }
});

module.exports = __toCommonJS(src_exports); // src/tag.tsx

var import_icon = require("@chakra-ui/icon");

var import_react_context = require("@chakra-ui/react-context");

var import_system = require("@chakra-ui/system");

var import_jsx_runtime = require("react/jsx-runtime");

var _ref = (0, import_react_context.createContext)({
  name: "TagStylesContext",
  errorMessage: "useTagStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Tag />\" "
}),
    _ref2 = _slicedToArray(_ref, 2),
    TagStylesProvider = _ref2[0],
    _useTagStyles = _ref2[1];

var _Tag = (0, import_system.forwardRef)(function (props, ref) {
  var styles = (0, import_system.useMultiStyleConfig)("Tag", props);
  var ownProps = (0, import_system.omitThemingProps)(props);

  var containerStyles = _objectSpread({
    display: "inline-flex",
    verticalAlign: "top",
    alignItems: "center",
    maxWidth: "100%"
  }, styles.container);

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(TagStylesProvider, {
    value: styles,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.span, _objectSpread(_objectSpread({
      ref: ref
    }, ownProps), {}, {
      __css: containerStyles
    }))
  });
});

_Tag.displayName = "Tag";

var _TagLabel = (0, import_system.forwardRef)(function (props, ref) {
  var styles = _useTagStyles();

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.span, _objectSpread(_objectSpread({
    ref: ref,
    noOfLines: 1
  }, props), {}, {
    __css: styles.label
  }));
});

_TagLabel.displayName = "TagLabel";

var _TagLeftIcon = (0, import_system.forwardRef)(function (props, ref) {
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_icon.Icon, _objectSpread({
    ref: ref,
    verticalAlign: "top",
    marginEnd: "0.5rem"
  }, props));
});

_TagLeftIcon.displayName = "TagLeftIcon";

var _TagRightIcon = (0, import_system.forwardRef)(function (props, ref) {
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_icon.Icon, _objectSpread({
    ref: ref,
    verticalAlign: "top",
    marginStart: "0.5rem"
  }, props));
});

_TagRightIcon.displayName = "TagRightIcon";

var TagCloseIcon = function TagCloseIcon(props) {
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_icon.Icon, _objectSpread(_objectSpread({
    verticalAlign: "inherit",
    viewBox: "0 0 512 512"
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)("path", {
      fill: "currentColor",
      d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
    })
  }));
};

TagCloseIcon.displayName = "TagCloseIcon";

var _TagCloseButton = (0, import_system.forwardRef)(function (props, ref) {
  var isDisabled = props.isDisabled,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var styles = _useTagStyles();

  var btnStyles = _objectSpread({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "0"
  }, styles.closeButton);

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.button, _objectSpread(_objectSpread({
    ref: ref,
    "aria-label": "close"
  }, rest), {}, {
    type: "button",
    disabled: isDisabled,
    __css: btnStyles,
    children: children || /* @__PURE__ */(0, import_jsx_runtime.jsx)(TagCloseIcon, {})
  }));
});

_TagCloseButton.displayName = "TagCloseButton"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  Tag: _Tag,
  TagCloseButton: _TagCloseButton,
  TagLabel: _TagLabel,
  TagLeftIcon: _TagLeftIcon,
  TagRightIcon: _TagRightIcon,
  useTagStyles: _useTagStyles
});